export enum ENTITY_LOCK_TYPE {
  UNAUTHORIZED = "unauthorized",
  MARKETING_MESSAGE = "marketing_message",
  INVISIBLE = "invisible",
}

export type MarketingContentState = {
  marketingHtmlUrl: string;
};
